import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Portal from "./Portal/Portal";
import Login from "./Portal/Login/Login";
import {useEffect} from "react";
import {setLoadingBarMethods} from "./Component/Loader/loadingBar";
import {useLoadingBar} from "react-top-loading-bar";


function App() {

    useEffect(() => {
        if ("Notification" in window) {
            Notification.requestPermission().then(permission => {
                console.log("وضعیت مجوز نوتیف:", permission);
            });
        }
    }, []);

    //loaders
    const { start, complete } = useLoadingBar({
        color: "red",
        height: 2,
    });
    useEffect(() => {
        setLoadingBarMethods(start, complete);
    }, [start, complete]);

    return (
        <Router navigator={Router}>
            <Routes>
                <Route path="/" element={<Portal/>}/>
                <Route path="/login" element={<Login/>}/>
            </Routes>
        </Router>

    );
}

export default App;